import { create } from "zustand";
import { persist } from "zustand/middleware";
import { AdminRole } from "../types";

type RoleStore = {
  loading: boolean;
  roles: AdminRole[];
  setRoles: (roles: AdminRole[]) => void;
};

export const useUserRoleStore = create<RoleStore>()(
  persist(
    (set) => ({
      loading: true,
      roles: [],
      setRoles: (roles) => set({ roles, loading: false }),
    }),
    {
      name: "user-role-store",
      partialize: (state) => ({ roles: state.roles }),
    },
  ),
);
